import {
  applyNotesVisibilityFilter,
  getEntitiesByType,
  transformFaqsNotesDocumentsEntity,
} from 'src/SharedCustomHooks/UseFaqsNotesDocumentsAPI/helpers';

const transformServiceRequestFaqsNotesDocuments = (rawData: any, user: any) => {
  const allNotes: any = getEntitiesByType(rawData, 'notes');
  const documents = getEntitiesByType(rawData, 'documents');

  const filteredNotes: any = applyNotesVisibilityFilter(allNotes, user);

  return {
    notes: filteredNotes,
    documents,
    faqsNotesDocuments: rawData,
  };
};

export {
  transformServiceRequestFaqsNotesDocuments,
  applyNotesVisibilityFilter,
  getEntitiesByType,
  transformFaqsNotesDocumentsEntity,
};
